// Shared static option lists + form-input class for the interview tabs.
export const PRIMARY_GOALS = ["Save Time", "Reduce Cost", "Increase Revenue", "Reduce Errors", "Scale Without Hiring"];
export const BUDGETS = ["Cost-Conscious", "Moderate", "Invest for ROI"];
export const APPROACHES = ["DIY", "Guided", "Done-for-You"];
export const FREQ = ["Daily", "Weekly", "Per Project", "Other"];
export const AFFECTS = ["Client", "Team Member", "Whole Team"];
export const SIGNALS = [
  "I don't have time to do this myself",
  "I've tried before and it didn't stick",
  "Low tech comfort (1-2)",
  "I'd rather someone just handle it",
  "Willing to invest for results",
];
export const STRENGTH = ["Low", "Medium", "High"];

export const inputCls = "rounded-none bg-ivory border-navy/15 focus-visible:ring-gold focus-visible:ring-1 focus-visible:ring-offset-0";
